import {
  BorrowerDrillDownQuery,
  SalesInventoryView,
} from 'ng2-app/models/sales-inventory/sales-inventory.model';

/** Load the summary (metric cards + rep rows) for a view/scope. `view = null` lets the api pick. */
export class LoadSalesInventorySummary {
  static readonly type = '[SalesInventory] Load Summary';
  constructor(
    public view: SalesInventoryView | null = null,
    public teamId: number | null = null,
    public overrideCache = false
  ) {}
}

/** Load the first page of borrower drill-down rows for a single lender user. */
export class LoadBorrowerDrillDown {
  static readonly type = '[SalesInventory] Load Borrower Drill-Down';
  constructor(
    public lenderUserId: number,
    public query: BorrowerDrillDownQuery,
    public overrideCache = false
  ) {}
}

/** Fetch and append the next keyset page of a rep's borrower drill-down. */
export class LoadMoreBorrowerDrillDown {
  static readonly type = '[SalesInventory] Load More Borrower Drill-Down';
  constructor(
    public lenderUserId: number,
    public query: BorrowerDrillDownQuery
  ) {}
}
